import { Section } from "design-system/molecules/Section"
import { UpdateCampaignSchemaFrontend } from "modules/campaigns/hooks/useCampaignForm"
import { isWhatsappTemplateTrigger } from "modules/campaigns/lib/configurationTabs"
import { useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { CampaignDetailResponseDataSchema } from "schema"
import { z } from "zod"

import { DefaultLanguageSelect } from "./DefaultLanguageSelect"
import { WhatsappTemplatesPicker } from "./templates/WhatsappTemplatesPicker"

type Props = {
  isEditable: boolean
  campaign: z.infer<typeof CampaignDetailResponseDataSchema>
}

export function TemplatesSubTab({ isEditable, campaign }: Props) {
  const { t } = useTranslation()
  const form = useFormContext<z.infer<typeof UpdateCampaignSchemaFrontend>>()
  const channel = form.watch("channel")
  const trigger = form.watch("trigger")

  if (!isWhatsappTemplateTrigger(channel, trigger)) return null

  return (
    <Section
      title={t("campaigns.configuration.setup.config.whatsappTemplates.title")}
      description={t("campaigns.configuration.setup.config.whatsappTemplates.description")}
      className="gap-3"
    >
      <DefaultLanguageSelect isDisabled={!isEditable} />
      <WhatsappTemplatesPicker campaignId={campaign.id} isDisabled={!isEditable} />
    </Section>
  )
}
